import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _class, _MessageBusService;
import MessageBus from "message-bus-client";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
let MessageBusService = disableImplicitInjections(_class = (_MessageBusService = class MessageBusService {
  static create() {
    return MessageBus;
  }
}, _defineProperty(_MessageBusService, "isServiceFactory", true), _MessageBusService)) || _class;
export { MessageBusService as default };